import React from "react";
import { Typography } from "@material-ui/core";

const NotFound = () => {
	return (
		<Typography variant="h5">
			Equipment not found.
		</Typography>
	);
};

export default NotFound;
